import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import BaseModule from "src/lt-module/base-module";
import Multiselect from "vue-multiselect";
import SelectPayMethod from "src/lt-module/general-module/SelectPayMethod.vue";
import VueSimpleSuggest from "vue-simple-suggest";
import imageUrl from "src/lt-module/utils/imageUrl.js";

Vue.config.productionTip = false;

Vue.filter("imageUrl", imageUrl);

Vue.component("Multiselect", Multiselect);
Vue.component("app-select-pay-method", SelectPayMethod);
Vue.component("VueSimpleSuggest", VueSimpleSuggest);

Vue.use(BaseModule, {
  locale: "es",
  defaultCurrency: 1,
  currencyList: {
    1: { name: "SOLES", symbol: "S/", code: "PEN" }
  }
});

store
  .dispatch("getUser")
  .then(
    () => {
      console.log("authenticated");
    },
    () => {
      console.log("the user is unauthenticated");
    }
  )
  .then(() => {
    console.log("the program is loading");
    new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount("#app");
  });
